import { CaseExportWithCaseInfo, UpdateCaseExportCollectSharedStateDocument } from "generated/graphql";
import { Box, Button, Dialog, DialogActions, DialogTitle } from "@mui/material";
import { P } from "theme/typography";
import useSnackbarPromise from "helpers/hooks/useSnackbarPromise";
import { runGqlMutation } from "gqlClient";

interface Props {
  exports: CaseExportWithCaseInfo[];
  open: boolean;
  onClose: () => void;
}

const updateCaseExportCollectSharedState = async (caseId: number, caseExportId: number, share: boolean) => {
  return runGqlMutation(UpdateCaseExportCollectSharedStateDocument, {
    caseId,
    caseExportId,
    share,
  });
};

const BulkShareDialog = ({ exports, open, onClose }: Props) => {
  const snackbar = useSnackbarPromise();

  const triggerBulkShare = async (share: boolean) => {
    try {
      await snackbar(
        Promise.all(
          exports.map((e) => updateCaseExportCollectSharedState(e.caseExport.caseId, e.caseExport.id, share))
        ),
        {
          successMessage: `${exports.length} ${exports.length === 1 ? "Export" : "Exports"} ${
            share ? "Shared" : "Not Shared"
          }`,
          errorMessage: `Unable to share ${exports.length === 1 ? "export" : "exports"}`,
        }
      );
      onClose();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Share Exports</DialogTitle>
      <Box sx={{ py: 2, px: 3, display: "flex", flexDirection: "column" }}>
        <P variant="base" sx={{ mb: 2 }}>
          Share or stop sharing all {exports.length} {exports.length === 1 ? "export" : "exports"}
        </P>
      </Box>
      <DialogActions>
        <Button variant="text" sx={{ mr: 1 }} onClick={onClose}>
          Close
        </Button>
        <Button variant="contained" onClick={() => triggerBulkShare(false)}>
          Stop Sharing
        </Button>
        <Button variant="contained" onClick={() => triggerBulkShare(true)}>
          Share
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BulkShareDialog;
